import { classnames } from '@bem-react/classnames'
import { IconInfo } from '@consta/icons/IconInfo'
import { Text } from '@consta/uikit/Text'
import { withTooltip } from '@consta/uikit/withTooltip'
import type { PropsWithChildren, ReactNode } from 'react'
import { memo } from 'react'

import css from './GroupingHeader.css'

type GroupingHeaderProps = {
  className?: string
  title: string
  info?: ReactNode
}

const IconInfoWithTooltip = withTooltip({
  mode: 'mouseover',
  direction: 'downCenter',
  appearTimeout: 300,
  size: 'l',
})(IconInfo)

export const GroupingHeader = memo<PropsWithChildren<GroupingHeaderProps>>(function GroupingHeader({
  className = '',
  title,
  info,
  children,
}) {
  return (
    <span className={classnames(css.header, className)}>
      <span className={css.title}>
        <Text size="xs" view="secondary">
          {title}
        </Text>
        {!!info && (
          <IconInfoWithTooltip size="xs" view="ghost" tooltipProps={{ tooltipContent: info }} />
        )}
      </span>
      <span className={css.controls}>{children}</span>
    </span>
  )
})
